import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const DEFAULT_TIMEOUT_MS = 60_000;
const UPLOAD_TIMEOUT_MS = 120_000;

export const api = axios.create({
    baseURL: API,
    headers: { "Content-Type": "application/json" },
    timeout: DEFAULT_TIMEOUT_MS,
});

export async function postContact(payload) {
    const { data } = await api.post("/contact", payload);
    return data;
}

export async function listInsights(lang = "en") {
    const { data } = await api.get(`/insights`, { params: { lang } });
    return data;
}

export async function getInsight(slug, lang = "en") {
    const { data } = await api.get(`/insights/${slug}`, { params: { lang } });
    return data;
}

export async function sendChatMessage({ session_id, message, language }) {
    const { data } = await api.post("/chat", { session_id, message, language });
    return data;
}

export async function postApplication(formData) {
    const { data } = await api.post("/careers", formData, {
        headers: { "Content-Type": "multipart/form-data" },
        timeout: UPLOAD_TIMEOUT_MS,
    });
    return data;
}
